export const infoData = {
	headline: 'We have been doing for 11 years',
	description:
		'We help you create unforgettable memories through multi-sensorial experiences. Including art, technology, music events pushed beyond every limit. We believe in helping people find the most exciting events in their lives.',

	bottomLine: [
		{ number: '5320+', numberText: 'Clients' },
		{ number: '350+', numberText: 'Awards' },
		{ number: '960+', numberText: 'Events Hosted' },
	],
};
